var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/core-js/modules/_parse-float.js
// module id = ../../../../core-js/modules/_parse-float.js
// module chunks = 1